import {IErrorOrError} from "../interfaces/error-or-error.interface";
import {ErrorType} from "../enums/error-type.enum";

// Implement the ErrorOrError class

export class ErrorOrError implements IErrorOrError {
    public code: string;
    public description: string;
    public type: ErrorType;
    public numericType: number;
    public metadata?: Record<string, any>;
    private constructor(
        code: string,
        description: string,
        type: ErrorType,
        metadata?: Record<string, any>
    ) {
        this.code = code;
        this.description = description;
        this.type = type;
        this.numericType = type;
        this.metadata = metadata;
    }

    static failure(
        code: string = "GENERAL.FAILURE",
        description: string = "A failure has occurred.",
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, ErrorType.FAILURE, metadata);
    }

    static unexpected(
        code: string = "GENERAL.UNEXPECTED",
        description: string = "An unexpected error has occurred.",
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, ErrorType.UNEXPECTED, metadata);
    }

    static validation(
        code: string = "GENERAL.VALIDATION",
        description: string = "A validation error has occurred.",
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, ErrorType.VALIDATION, metadata);
    }

    static conflict(
        code: string = "GENERAL.CONFLICT",
        description: string = "A conflict error has occurred.",
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, ErrorType.CONFLICT, metadata);
    }

    static notFound(
        code: string = "GENERAL.NOT_FOUND",
        description: string = "A 'Not Found' error has occurred.",
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, ErrorType.NOTFOUND, metadata);
    }

    static unAuthorized(
        code: string = "GENERAL.UNAUTHORIZED",
        description: string = "An 'Unauthorized' error has occurred.",
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, ErrorType.UNAUTHORIZED, metadata);
    }

    static forbidden(
        code: string = "GENERAL.FORBIDDEN",
        description: string = "A 'Forbidden' error has occurred.",
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, ErrorType.FORBIDDEN, metadata);
    }

    static custom(
        type: ErrorType,
        code: string,
        description: string,
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, type, metadata);
    }

    toErrorMessage(): string {
      if (this.type == ErrorType.VALIDATION) {
        return this.description;
      }

      switch (this.type) {
        case ErrorType.FORBIDDEN:
          return 'GENERAL.MSG_FORBIDDEN'
        case ErrorType.UNAUTHORIZED:
          return 'GENERAL.MSG_UNAUTHORIZED'
        case ErrorType.NOTFOUND:
          return 'GENERAL.MSG_NOT_FOUND'
        default:
          return 'GENERAL.MSG_UNEXPECTED'
      }
    }
}
